import { n as e, t } from "../../chunks/index.es.CfT5btWg.js";
import { Transforms as n } from "slate";
//#region lib/List/lib/actionHandler.ts
var r = (r, i) => {
	let a = ["core/unordered-list", "core/ordered-list"].includes(i) ? i : "core/unordered-list", o = e.includes(r, a);
	n.unwrapNodes(r, {
		match: (n) => !e.isEditor(n) && t.isElement(n) && ["core/unordered-list", "core/ordered-list"].includes(n.type),
		split: !0
	});
	let s = {
		type: o ? "core/text" : `${a}/list-item`,
		properties: {}
	};
	n.setNodes(r, s, { match: (n) => !e.isEditor(n) && t.isElement(n) && n.class === "text" }), o || n.wrapNodes(r, {
		id: crypto.randomUUID(),
		class: "text",
		type: a,
		children: []
	});
};
//#endregion
export { r as actionHandler };
